// extracted by mini-css-extract-plugin
module.exports = {"container":"DropContainer_container__TmCYD","container--visible":"DropContainer_container--visible__KfjmV"};